<script>
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  //MDBTabs,
  //MDBTabNav,
  //MDBTabContent,
  //MDBTabItem,
  //MDBTabPane,
  MDBBtn,
} from "mdb-vue-ui-kit";
import NumInput from "./helpers/NumInput.vue";
import ToolTip from "./helpers/ToolTip.vue";
import { scroller } from "vue-scrollto/src/scrollTo";
import clientConfig from "/src/config/foresters-financial";
import { mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";

//import LifetimeSliderInput from "@lifetime-gallagher/lifetime-slider-input";

export default {
  name: "EditableAndAssumptionsPanel",

  components: {
    MDBContainer,
    MDBRow,
    MDBCol,
    //MDBTabs,
    //MDBTabNav,
    //MDBTabContent,
    //MDBTabItem,
    //MDBTabPane,
    MDBBtn,
    NumInput,
    ToolTip,
    //LifetimeSliderInput,
  },

  data() {
    return {
      windowWidth: window.innerWidth,
      clientConfig,
      activeTabId: "ex1-1",

      
      grossReturn: 0,
      feePercentageOnBalance: 0,
      feePercentageOnBalanceCapped: 0,
      feePercentageOnContributions: 0,
    };
  },

  mounted() {
    window.onresize = () => {
      this.windowWidth = window.innerWidth;
    };
  },

  computed: {
    ...mapGetters([
      "appVersion",
      "debugMode",
      "analyticsPageNames",
      "activeTab",
      "lastActiveTab",

      "data",
      "availableInvestmentOptions",
      "userDefinedInvestmentReturnRate",
    ]),

    ...mapFields([
      "userDefinedInvestment",
      "customInvestmentReturnRate",
      "investmentRisk",
      "wageInflation",
      "priceInflation",
      "assetFee",
    ]),

    customInvestmentOption() {
      return null; // this.superEngineConfig.InvestmentOptions['custom'];
    },

    filteredInvestmentOptions() {
      const options = [];
      for (let option of this.availableInvestmentOptions) {
        if (option.value !== 5) {
          options.push(option);
        }
      }
      return options;
    }
  },

  methods: {
    clickToTab(tabNum) {
      const scrollTo = scroller();
      this.$store.commit("setActiveTab", tabNum);
      scrollTo("#ffApp");

      this.$triggerIframeAnalytics({
        event: "calculator",
        calculator_name: "Investment Forecaster",
        calculator_section: this.analyticsPageNames[this.lastActiveTab],
        calculator_step: "Back",
      });

      if (this.debugMode)
        console.log(
          "GTM Event: calculator_name: Investment Forecaster, calculator_section: " + 
          this.analyticsPageNames[this.lastActiveTab] + 
          ", calculator_step: Back"
        );


      // Pretend this is an onload of the next page
      setTimeout(() => {
        this.$triggerIframeAnalytics({
          event: "calculator",
          calculator_name: "Investment Forecaster",
          calculator_section: this.analyticsPageNames[this.activeTab],
          calculator_step: "Start",
        });

        if (this.debugMode)
          console.log(
            "GTM Event: calculator_name: Investment Forecaster, calculator_section: " + 
            this.analyticsPageNames[this.activeTab] + 
            ", calculator_step: Start"
          );
      }, 100);
    },

    setCustomValuesFromPreset(event) {
      //const selectedInvestmentOption = event.target.options[event.target.options.selectedIndex];
      if (event.target.options.selectedIndex > 0) {
        this.customInvestmentReturnRate = this.userDefinedInvestmentReturnRate;
        this.investmentRisk = 5;
      } else {
        this.investmentRisk = 3;
      }
    },
  },

  watch: {
    // grossReturn(newVal) {
    //   this.customInvestmentOption.grossReturn = this.$div100(newVal);
    //   this.customInvestmentOption.taxableFraction = this.calculateClosestTaxableIncome(this.customInvestmentOption.grossReturn);
    // },

    // feePercentageOnBalance(newVal) {
    //   this.customInvestmentOption.feePercentageOnBalance = this.$div100(newVal);
    // },
  },
};
</script>

<template>
  <MDBContainer fluid class="p-0">
    <div class="content-section col-md-11 col-lg-10 mx-auto text-center">
      <MDBRow class="p-0">
        <MDBCol class="mx-auto">

          <div class="assumptions-wrapper my-4 mx-5">
            <MDBRow>
              <MDBCol class="form-group about px-0">
                <label class="main-label">
                  Wage inflation (p.a.)

                  <ToolTip text="Default results are expressed in today's dollars by allowing for future expected wage inflation each year. Super projections are discounted to present values at this rate. This is intended to reflect both price increases and general standard of living increases. This has the effect of preserving an individual's relative standard of living.">
                    <span class="icon-info"></span>
                  </ToolTip>
                </label>

                <MDBRow>
                  <MDBCol sm="7" md="6" lg="5">
                    <NumInput
                      v-model.number.lazy="wageInflation"
                      divClass="mb-3"
                      cssClass="form-control"
                      :options="{
                        precision: { min: 1, max: 2 },
                        currencyDisplay: 'hidden',
                        valueRange: { min: data.wageInflation.min, max: data.wageInflation.max }
                      }"
                      name="wageInflation"
                      label="Percentage"
                      placeholder="Percentage"
                      :addSuffix="true"
                      suffixText="%"
                    />
                  </MDBCol>
                </MDBRow>
              </MDBCol>
            </MDBRow>

            <MDBRow>
              <MDBCol class="form-group about px-0">
                <label class="main-label">
                  Price inflation (p.a.)

                  <ToolTip text="Price inflation (CPI) is assumed to be 2.5% p.a., which is included in the returns.">
                    <span class="icon-info"></span>
                  </ToolTip>
                </label>

                <MDBRow>
                  <MDBCol sm="7" md="6" lg="5">
                    <NumInput
                      v-model.number.lazy="priceInflation"
                      divClass="mb-3"
                      cssClass="form-control"
                      :options="{
                        precision: { min: 1, max: 2 },
                        currencyDisplay: 'hidden',
                        valueRange: { min: data.priceInflation.min, max: data.priceInflation.max }
                      }"
                      name="priceInflation"
                      label="Percentage (p.a.)"
                      placeholder="Percentage (p.a.)"
                      :addSuffix="true"
                      suffixText="%"
                    />
                  </MDBCol>
                </MDBRow>
              </MDBCol>
            </MDBRow>

            <MDBRow>
              <MDBCol class="form-group about px-0">
                <label class="main-label">
                  Fees (no cap)

                  <ToolTip text="Asset fee">
                    <span class="icon-info"></span>
                  </ToolTip>
                </label>

                <MDBRow>
                  <MDBCol sm="7" md="6" lg="5">
                    <NumInput
                      v-model.number.lazy="assetFee"
                      divClass="mb-3"
                      cssClass="form-control"
                      :options="{
                        precision: { min: 1, max: 2 },
                        currencyDisplay: 'hidden',
                        valueRange: { min: data.assetFee.min, max: data.assetFee.max }
                      }"
                      name="priceInflation"
                      label="Percentage (p.a.)"
                      placeholder="Percentage (p.a.)"
                      :addSuffix="true"
                      suffixText="%"
                    />
                  </MDBCol>
                </MDBRow>
              </MDBCol>
            </MDBRow>

            <MDBRow>
              <MDBCol class="form-group about px-0">
                <label class="section-label">
                  Edit user defined investment option
                </label>

                <label class="main-label">
                  Create user defined investment option based on:
                </label>
                <MDBRow>
                  <MDBCol sm="7" md="6" lg="5">
                    <div class="form-floating mb-3">
                      <select
                        id="userDefinedInvestment"
                        name="userDefinedInvestment"
                        class="form-select form-control"
                        v-model="userDefinedInvestment"
                        @change="setCustomValuesFromPreset"
                      >
                        <option selected value="">--choose--</option>
                        <option
                          v-for="(option, index) in filteredInvestmentOptions"
                          :key="index"
                          :value="option.value"
                        >
                          {{ option.label }}
                        </option>
                      </select>

                      <label
                        for="userDefinedInvestment"
                        v-if="userDefinedInvestment != ''"
                      >
                        Option
                      </label>
                    </div>
                  </MDBCol>
                </MDBRow>
              </MDBCol>
            </MDBRow>

            <div v-if="userDefinedInvestment != ''">
              <MDBRow>
                <MDBCol class="form-group about px-0">
                  <label class="section-label">
                    Your user defined investment option:
                  </label>

                  <label class="main-label">
                    Total return (p.a) 

                    <ToolTip text="This is the assumed annualised investment option return (min 0.1%, max 10%).">
                      <span class="icon-info"></span>
                    </ToolTip>
                  </label>

                  <MDBRow>
                    <MDBCol sm="7" md="6" lg="5">
                      <NumInput
                        v-model.number.lazy="customInvestmentReturnRate"
                        divClass="mb-3"
                        cssClass="form-control"
                        :options="{
                          precision: { min: 0, max: 2 },
                          currencyDisplay: 'hidden',
                          valueRange: { min: data.customInvestmentReturn.min, max: data.customInvestmentReturn.max }
                        }"
                        name="customInvestmentReturnRate"
                        label="Percentage"
                        placeholder="Percentage"
                        :addSuffix="true"
                        suffixText="%"
                      />
                    </MDBCol>
                  </MDBRow>
                </MDBCol>
              </MDBRow>

              <!-- <MDBRow>
                <MDBCol class="form-group about px-0">
                  <label class="main-label">
                    Asset based fee (no cap)

                    <ToolTip text="A percentage fee deducted from before-tax investment returns.">
                      <span class="icon-info"></span>
                    </ToolTip>
                  </label>

                  <MDBRow>
                    <MDBCol sm="7" md="6" lg="5">
                      <NumInput
                        v-model.number.lazy="feePercentageOnBalance"
                        divClass="mb-3"
                        cssClass="form-control"
                        :options="{
                          precision: { min: 0, max: 2 },
                          currencyDisplay: 'hidden',
                          valueRange: { min: data.feePercentageOnBalance.min, max: data.feePercentageOnBalance.max }
                        }"
                        name="feePercentageOnBalance"
                        label="Percentage"
                        placeholder="Percentage"
                        :addSuffix="true"
                        suffixText="%"
                      />
                    </MDBCol>
                  </MDBRow>
                </MDBCol>
              </MDBRow> -->

            </div>
          </div>
        </MDBCol>
      </MDBRow>
    </div>

    <div class="sub-section-header p-0 col-md-11 col-lg-10 mx-auto mt-4">
      <MDBRow>
        <MDBCol md="11" class="mx-0 my-1 pb-4">
          <MDBBtn
            color="primary"
            class="btn btn-primary"
            @click="clickToTab(lastActiveTab)"
            aria-label="Continue button"
          >
            Back to calculator
          </MDBBtn>
        </MDBCol>
      </MDBRow>
    </div>
  </MDBContainer>
</template>
